import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';

// import AccountPopover from './AccountPopover';

// ----------------------------------------------------------------------
import { useLocation } from 'react-router-dom';
import DomainSearch from '../../../components/addVendorByClient/domainSearch';
import HamburgerMenu from '../../../pages/HamburgerMenu';

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav, isShowSearch, setIsSearching }) {
  const theme = localStorage.getItem("theme");
  let location = useLocation()
  // const [showAddButton, setShowAddButton] = useState((localStorage.getItem("roleId") === "1") ? true : false);
  const [modelOpen, setModelOpen] = useState(false);
  // const handleModelOpen = () => setModelOpen(true);
  const handleModelClose = () => setModelOpen(false);
  

  return (

    <StyledRoot className={`${theme === "Light" ? "light-mode-class" : "dark-mode-class"}`}>
      <StyledToolbar className={`search-icon topHeader-move ${location?.pathname?.includes("clientChat") ? "chatheader-removebg" : ""}`}>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}>
           <HamburgerMenu />
        </IconButton>
        {/* <Searchbar showSearch={showSearch} isShowSearch={isShowSearch} setIsSearching={setIsSearching} /> */}

        <Box sx={{ flexGrow: 1 }} />
        {/* { showAddButton && <Button
          variant="contained"
          className="add-vendor-btn"
          startIcon={<Iconify icon="eva:plus-fill" />}
          onClick={handleModelOpen}

        >
          Add Vendor
        </Button>} */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          {/* <LanguagePopover />
          <NotificationsPopover /> */}
          {/* <AccountPopover /> */}
        </Stack>
      </StyledToolbar>
      <DomainSearch
        open={modelOpen}
        handleClose={handleModelClose} />
    </StyledRoot>
  );
}
